export default "__VITE_ASSET__B6BQj9di__"